import angular from 'angular';

import '../../../services/datastorage';
import '../../../services/product';
import '../../../services/favorites';

angular.module('folkeuni').component('addToFavorites', {
  bindings: {
    currentEvent: '<'
  },
  controller: function(DataStorage, Product, Favorites, $scope, $timeout) {
    var $ctrl = this;
    $ctrl.isFavorite = false;
    $ctrl.statusShow = false;

    var timer = $timeout(function(){
      $ctrl.statusShow = false;
    },2000)


    $ctrl.addToFavorites = function() {  
      var eventData = {
        id: $ctrl.currentEvent.id,
        name: $ctrl.currentEvent.name,
        url: $ctrl.currentEvent.defaultUrl,
        endDate: $ctrl.currentEvent.endDate,
        startDate: $ctrl.currentEvent.startDate
      }
      var favoriteList = [];
      
      // Hent nuværende liste ud
      Favorites.getFavorites().then(function(list) {
        favoriteList = list;
        updateFavoriteList();

 

      }, function() {
        updateFavoriteList();
      });

      var updateFavoriteList = function() {
        if (!$ctrl.isFavorite) {
          favoriteList.push(eventData);
          
          Favorites.setFavorites(favoriteList).then(function(list) {
            $ctrl.emitUpdated(list);
          })
          $ctrl.isFavorite = true;
        }
      }

    }

    $ctrl.toggleFavorite = function() {
      if ($ctrl.isFavorite) {
        Product.removeAsFavorite($ctrl.currentEvent.id).then(function(list) {
          $ctrl.isFavorite = false;
          $ctrl.emitUpdated(list);

          $timeout.cancel(timer);
          $ctrl.statusShow = true;
          $ctrl.success = true;
          $ctrl.statusMessage = "Holdet er nu fjernet fra din favoritliste";

          timer = $timeout(function(){
            $ctrl.statusShow = false;
          },2000);
        })
      }
      else {
        $ctrl.addToFavorites();

        $timeout.cancel(timer);
        $ctrl.statusShow = true;
        $ctrl.success = true;
        $ctrl.statusMessage = "Holdet er nu tilføjet til din favoritliste";

        timer = $timeout(function(){
          $ctrl.statusShow = false;
        },2000);

      }
    }

    $ctrl.emitUpdated = (list) => {
      $scope.$emit('updateFavorites', list);
      const updateEvent = new Event('favoritesUpdated');
      window.dispatchEvent(updateEvent);
    };

    $ctrl.checkFavoriteStatus = function() {
      Favorites.isFavorite($ctrl.currentEvent.id).then(function(isFavorite) {
        $ctrl.isFavorite = isFavorite;
      })
    }

    $ctrl.$onInit = function() {
      $ctrl.checkFavoriteStatus();
    }

    $scope.$on('changeFavorites', function(e, data) {
      $ctrl.favoriteList = data;
      $ctrl.checkFavoriteStatus();
    });
  },
  templateUrl: '/shop-dist/templates/add-to-favorites.html',
  transclude: false
});
